// Montessori
import React from 'react';
import MootCourt2025  from 'views/MootCourt2025';

const Montessoripage = () => {
  return <MootCourt2025/>;
};

export default Montessoripage;